<template>
	<div>
		<v-card>
			<v-card-title class="mt-3">
				<h1 class="ml-2">Korespondencja</h1>
			</v-card-title>
			<v-container fluid>
				<v-layout>
					<v-flex xs6>
						<h2>Pisma</h2>
						<v-container fluid>
							<v-layout style="position: relative">
								<v-flex ma-3 xs6>
									<v-select
										:items="templates"
										item-text="name"
										aria-label="template"
										v-model="selectedTemplate"
										item-value="id"
										return-object
									></v-select>
								</v-flex>
								<v-flex ml-5>
									<v-btn @click="getCorrespondence"
										style="float: left; margin-top: 13px;">
										Generuj pismo
									</v-btn>
								</v-flex>
							</v-layout>
						</v-container>
					</v-flex>
					<v-flex xs6>
						<project-file-view
							button-label="Dodaj pismo"
							files-label="Dodane pisma:"
							:load-files="loadFiles"
							upload-endpoint="/project/correspondence"
							:delete-function="deleteFile"
						/>
					</v-flex>
				</v-layout>
				<v-layout><h3>Uwagi</h3></v-layout>
			<v-layout>
				<v-flex>
					<v-textarea outline auto-grow v-model="project.correspondenceRemarks"
						browser-autocomplete="off" aria-label="correspondence remarks"></v-textarea>
				</v-flex>
			</v-layout>
			<v-btn primary @click="saveProjectCorrespondenceRemarks">Zapisz</v-btn>
			</v-container>
		</v-card>
	</div>
</template>

<script>
	import {Files} from "@/utils/Files";
	import {Department} from "@/api/generated/Department";
	import {Project} from "@/api/generated/Project";
	import ProjectFileView from "./components/ProjectFileView";


	export default {
		name: "ProjectCorrespondenceView",
		components: {ProjectFileView},
		mixins: [Files],

		data() {
			return {
				templates: [],
				selectedTemplate: null,
			};
		},

		methods: {
			getCorrespondence() {
				if (this.selectedTemplate) {
					this.downloadFileAsBlob(this, this.generateCorrespondence(this.$route.params.projectId, this.selectedTemplate.id), this.selectedTemplate.name);
				}
			},

			loadFiles(ctx) {
				return Project.getCorrespondence(ctx, this.$route.params.projectId, onSuccess => {
					ctx.uploadedFiles = onSuccess;
				});
			},

			deleteFile(ctx, fileHash) {
				Project.deleteCorrespondence(ctx, this.$route.params.projectId, fileHash,
					() => {
						ctx.$messagesBus.$emit("success", "Dokument został usunięty");
						ctx.refresh();
					},
					() => {
						ctx.$messagesBus.$emit("error", "Nie udało się usunąć dokumentu");
					});
			},

			saveProjectCorrespondenceRemarks() {
				Project.putCorrespondenceRemarks(this, this.$route.params.projectId, {body: this.project.correspondenceRemarks});
			}
		},

		props: {
			project: {
				type: Object
			},
		},

		mounted () {
			Department.getCorrespondences(this, this.$route.params.contestId, success => {
				this.templates = success;
			});
		},
	};
</script>

<style scoped>

</style>
